import { useEffect, useRef, useState } from "react";
import { useLazyQuery } from "shared/hooks/useApi";
import { COMPANIES } from "utils/api/graphql/queries/companies";

const DEBOUNCE_MS = 300;
const MIN_QUERY_LENGTH = 2;

export const useCompanySearch = () => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const ref = useRef([]);
  const [fetchCompanies] = useLazyQuery(COMPANIES, {
    fetchPolicy: "no-cache",
    onCompleted: ({ companies }) => setResults(companies || []),
  });

  useEffect(() => {
    const trimmed = query.trim();
    if (trimmed.length < MIN_QUERY_LENGTH) {
      setResults([]);
      return undefined;
    }
    const handle = setTimeout(() => {
      fetchCompanies({ variables: { query: trimmed } });
    }, DEBOUNCE_MS);
    return () => clearTimeout(handle);
  }, [query, fetchCompanies]);

  ref.current = results;
  return { query, setQuery, results, resultsRef: ref };
};
